import React, { useState } from 'react';

const InterviewDoctorOrthoA1 = ({ onClose, shareUrl, shareTitle, shareText }) => {
  const [showShareMenu, setShowShareMenu] = useState(false);

  const handleShareClick = (platform) => {
    const url = shareUrl || window.location.href;
    const title = shareTitle || 'Interview With an Orthopedic Surgeon';
    const text = shareText || 'Read this informative orthopedic interview.';

    if (platform === 'whatsapp') {
      window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`);
    } else if (platform === 'email') {
      window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + "\n\n" + url)}`;
    } else if (platform === 'copy') {
      navigator.clipboard?.writeText(url).then(() => {
        alert('Link copied to clipboard!');
      }).catch(() => {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        alert('Link copied to clipboard!');
      });
    }
    setShowShareMenu(false);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.35)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflowY: 'auto',
        paddingTop: '20px',
        paddingBottom: '20px',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 10,
          padding: 24,
          minWidth: 320,
          maxWidth: 600,
          boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
          position: 'relative',
          margin: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'none',
            border: 'none',
            fontSize: 24,
            color: '#1976d2',
            cursor: 'pointer',
            padding: 0,
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title="Close"
        >
          ✕
        </button>

        <h2 style={{ fontSize: '1.1rem', color: '#1976d2', marginTop: 0, marginBottom: 12, paddingRight: 40 }}>
          Dr. Rajesh Patel – Orthopedic Surgery Innovation
        </h2>

        <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: 16, fontStyle: 'italic' }}>
          "Breaking Boundaries in Joint Reconstruction"
        </p>

        <div style={{ fontSize: '0.9rem', lineHeight: 1.6, color: '#333' }}>
          <p>
            <strong>Q: Dr. Patel, tell us about your latest breakthrough in orthopedic surgery.</strong>
          </p>
          <p>
            <strong>Dr. Rajesh Patel:</strong> We've recently developed a minimally invasive technique for knee cartilage regeneration using stem cells derived from bone marrow. This approach significantly reduces recovery time and improves patient outcomes. The results are remarkable – patients return to normal activities within weeks instead of months.
          </p>

          <p>
            <strong>Q: How does this technique differ from traditional methods?</strong>
          </p>
          <p>
            Unlike conventional arthroscopy, our method involves targeted stem cell injection with real-time ultrasound guidance. The beauty of this approach is that it stimulates the body's natural healing mechanisms rather than relying solely on external interventions. We've seen cartilage regeneration in approximately 80% of our trial cases.
          </p>

          <p>
            <strong>Q: What are the challenges you've faced?</strong>
          </p>
          <p>
            The primary challenge is ensuring consistent stem cell quality and viability. We've invested heavily in cell preservation technology and developed protocols that maintain cellular potency. Additionally, patient selection is crucial – we've refined our diagnostic criteria to identify candidates most likely to benefit from this treatment.
          </p>

          <p>
            <strong>Q: What does the future hold for orthopedic surgery?</strong>
          </p>
          <p>
            I believe we're at the cusp of a revolution. Combining regenerative medicine with robotics and AI-guided surgery will allow us to achieve unprecedented precision. Within the next decade, we'll likely see treatments for previously irreversible conditions like advanced arthritis becoming routine. Our focus now is on making these technologies accessible to patients across all socioeconomic backgrounds.
          </p>

          <p>
            <strong>Q: Any advice for young orthopedic surgeons entering the field?</strong>
          </p>
          <p>
            Stay curious and embrace innovation. Surgery is both an art and a science. Don't be afraid to challenge conventional wisdom, but always prioritize patient safety and evidence-based practice. Collaborate with researchers, engineers, and other specialties – some of our best breakthroughs come from interdisciplinary teamwork.
          </p>
        </div>

        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #eee', fontSize: '0.85rem', color: '#999' }}>
          <p style={{ margin: 0 }}>Dr. Rajesh Patel is a leading orthopedic surgeon with 18 years of experience in joint reconstruction and regenerative medicine.</p>
        </div>

        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #ddd', display: 'flex', gap: '1rem', alignItems: 'center', position: 'relative' }}>
          <div style={{ position: 'relative' }}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowShareMenu(!showShareMenu);
              }}
              style={{
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                padding: '8px 12px',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: '0.75rem',
                minWidth: 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
              title="Share"
            >
              <span style={{ lineHeight: 1 }}>Share</span>
              <span style={{ fontSize: '0.8rem', opacity: 0.9 }}>▾</span>
            </button>

            {showShareMenu && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '100%',
                  left: 0,
                  background: '#fff',
                  border: '1px solid #ddd',
                  borderRadius: 4,
                  boxShadow: '0 -2px 8px rgba(0,0,0,0.15)',
                  marginBottom: 8,
                  minWidth: 140,
                  zIndex: 10,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => handleShareClick('whatsapp')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    borderBottom: '1px solid #eee',
                    color: '#25D366',
                    fontWeight: 500,
                  }}
                >
                  WhatsApp
                </button>
                <button
                  onClick={() => handleShareClick('email')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    borderBottom: '1px solid #eee',
                    color: '#333',
                  }}
                >
                  Email
                </button>
                <button
                  onClick={() => handleShareClick('copy')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    color: '#333',
                  }}
                >
                  Copy Link
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewDoctorOrthoA1;
